import {
  type Option,
  type OrderDTO,
  type PaymentProviderConfig,
  type ShippingProviderConfig
} from 'ecosystem'
import { provisionOrderKlarnaProvider } from './provisionOrderKlarnaProvider'
import { provisionOrderNexiProvider } from './provisionOrderNexiProvider'
import { type OrderProvisionResult, type ProvisionOrderOptions } from './types'
import { provisionOrderSveaProvider } from './provisionOrderSveaProvider'
import { provisionOrderQliroProvider } from './provisionOrderQliroProvider'
import { provisionOrderBriqpayProvider } from './provisionOrderBriqpayProvider'

export const provisionOrder = async (
  orderId: string,
  paymentProviderConfig?: PaymentProviderConfig,
  shippingProviderConfig?: ShippingProviderConfig,
  options?: ProvisionOrderOptions
): Promise<Option<OrderProvisionResult>> => {
  const paymentProviderName = paymentProviderConfig?.providerName ?? 'KLARNA'
  let storefrontOrder: Option<OrderDTO> = null
  let shippingProviderResult: OrderProvisionResult['shippingProviderResult']

  const paymentProviderResult: OrderProvisionResult['paymentProviderResult'] = {
    providerName: paymentProviderName
  }

  switch (paymentProviderName) {
    case 'KLARNA':
      {
        const provisionOrderKlarnaProviderResult = await provisionOrderKlarnaProvider(
          orderId,
          paymentProviderConfig,
          shippingProviderConfig,
          options
        )
        storefrontOrder = provisionOrderKlarnaProviderResult?.storefrontOrder ?? null
        paymentProviderResult.klarnaResponse = provisionOrderKlarnaProviderResult?.klarnaOrder
        shippingProviderResult = provisionOrderKlarnaProviderResult?.shippingProviderResult
      }
      break

    case 'NEXI':
      {
        const provisionOrderNexiProviderResult = await provisionOrderNexiProvider(
          orderId,
          paymentProviderConfig,
          shippingProviderConfig,
          options
        )
        storefrontOrder = provisionOrderNexiProviderResult?.storefrontOrder ?? null
        paymentProviderResult.nexiResponse = provisionOrderNexiProviderResult?.nexiResponse
        shippingProviderResult = provisionOrderNexiProviderResult?.shippingProviderResult
      }
      break

    case 'SVEA':
      {
        const provisionOrderSveaProviderResult = await provisionOrderSveaProvider(
          orderId,
          paymentProviderConfig,
          shippingProviderConfig,
          options
        )
        storefrontOrder = provisionOrderSveaProviderResult?.storefrontOrder ?? null
        paymentProviderResult.sveaResponse = provisionOrderSveaProviderResult?.sveaResponse
        shippingProviderResult = provisionOrderSveaProviderResult?.shippingProviderResult
      }
      break
    case 'QLIRO':
      {
        const provisionOrderQliroProviderResult = await provisionOrderQliroProvider(
          orderId,
          paymentProviderConfig,
          shippingProviderConfig,
          options
        )
        storefrontOrder = provisionOrderQliroProviderResult?.storefrontOrder ?? null
        paymentProviderResult.qliroResponse = provisionOrderQliroProviderResult?.qliroResponse
        shippingProviderResult = provisionOrderQliroProviderResult?.shippingProviderResult
      }
      break
    case 'BRIQPAY':
      {
        const provisionOrderBriqpayProviderResult = await provisionOrderBriqpayProvider(
          orderId,
          paymentProviderConfig,
          shippingProviderConfig,
          options
        )
        storefrontOrder = provisionOrderBriqpayProviderResult?.storefrontOrder ?? null
        paymentProviderResult.briqpayResponse = provisionOrderBriqpayProviderResult?.briqpayResponse
        shippingProviderResult = provisionOrderBriqpayProviderResult?.shippingProviderResult
      }
      break

    case 'LEDYER':
      // todo: add LEDYER
      break
  }

  return {
    storefrontOrder,
    paymentProviderResult,
    ...(shippingProviderResult && {
      shippingProviderResult
    })
  }
}
